import { atom } from 'recoil';

const snackbarAtom = atom({
  key: 'snackbarState',
  default: { open: false, severity: 'success', text: 'Test recoil' },
});

export default snackbarAtom;
